import React, { useEffect, useState } from "react";
import { ActivityIndicator, Dimensions, Image, Linking, ScrollView, Text, TouchableOpacity, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/core";

import HeaderDefault from "../../components/HeaderDefault";

import { styles } from "./styles";

import AsyncStorage from "@react-native-async-storage/async-storage";
import toast from "../../utils/toast";
import CreditCardForm from "../../components/CreditCardForm";
import GradientButton from "../../components/GradientButton";

const DepositNewCreditCard = () => {
  const navigation = useNavigation();

  function onSubmit(data) {
    const { creditCard, creditCardHolderInfo } = data;
    navigation.navigate({ name: "DepositCreditCardSummary", params: { creditCard, creditCardHolderInfo } });
  }

  return (
    <View style={{ flex: 1 }}>
      <HeaderDefault title={"Depositar BRL"} />
      <View style={styles.container}>
        <CreditCardForm onSubmit={onSubmit} submitText='Continuar' />
      </View>
    </View>
  );
};

export default DepositNewCreditCard;
